// extracted by mini-css-extract-plugin
export default {"banner":"HostBanner_banner__GCo3n","noneUpcoming":"HostBanner_noneUpcoming__HbOoF"};